export default __webpack_public_path__ + "static/media/trac_2.d1f63944.png";